import { Component } from 'react';
import no_image_availabe from '../../assets/images/activ-reward/no-image-available.jpg';
import { Modal, Button } from 'react-bootstrap';
import NumberFormat from 'react-number-format';

class Reward extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showHide: false
        }
    }

    handleModalShowHide() {
        this.setState({ showHide: !this.state.showHide });
    }

    render() {
        const reward = this.props.reward;
        const img_url = reward.images.length > 0 ? reward.images[0].url : no_image_availabe;
        return (
            <>
                <div className="image text-center">
                    <img src={img_url} className="img-fluid mx-auto rounded" alt="Reward" />
                </div>
                <div className="title text-center" dangerouslySetInnerHTML={{ __html: reward.title }} />
                <p className="mt-2 text-center" dangerouslySetInnerHTML={{ __html: reward.description }} />
                <div className="text-right">
                    <Button variant="danger" onClick={() => this.handleModalShowHide()}>
                        View
                    </Button>
                </div>
                <Modal show={this.state.showHide} size="lg">
                    <div className="modal-header">
                        <h5>&nbsp;</h5>
                        <i onClick={() => this.handleModalShowHide()} className="fa fa-close"></i>
                    </div>
                    <Modal.Body>
                        <div className="image text-center">
                            <img src={img_url} className="img-fluid mx-auto" alt="Reward" />
                        </div>
                        <div className="title text-center mt-3 font-weight-bold" dangerouslySetInnerHTML={{ __html: reward.title }} />
                        {reward.old_price > 0 && 
                            <div className="text-center mt-3">
                                <span>BEFORE: </span>
                                <span className="font-weight-bold"><del className="text-danger"><NumberFormat value={reward.old_price} prefix="RM" decimalScale="2" fixedDecimalScale={true} displayType="text" /></del></span>
                                <span className="ml-5">NOW: </span>
                                <span className="font-weight-bold"><NumberFormat value={reward.price} prefix="RM" decimalScale="2" fixedDecimalScale={true} displayType="text" /></span>
                            </div>
                        }
                        <h5 className="text-center mt-3">TERMS</h5>
                        <p className="mt-3 text-left" dangerouslySetInnerHTML={{ __html: reward.terms }} />
                        <div className="text-center">SKU: {reward.sku}</div>
                        <p className="mt-3 text-left" dangerouslySetInnerHTML={{ __html: reward.description }} />
                        <h5 className="text-center">REWARDS PARTNER</h5>
                        <p className="mt-3 text-center">{reward.activ_partner_name}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={() => this.handleModalShowHide()}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default Reward;
